import { useEffect } from 'react';

// We allow useForm import here because this hook extends its functionality

// eslint-disable-next-line no-restricted-imports
import { Path, UseFormProps, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

/**
 * A custom hook that wraps the useForm hook from react-hook-form.
 * It also triggers validation on language change for fields that currently have errors.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useBaseForm<T extends Record<string, any>>(props?: UseFormProps<T>) {
  const methods = useForm<T>(props);
  const { t } = useTranslation();

  const {
    formState: { errors },
    trigger
  } = methods;

  useEffect(() => {
    const existingErrorFields = Object.keys(errors) as Path<T>[];
    if (existingErrorFields.length > 0) {
      // Re-validate only the fields that currently have errors
      trigger(existingErrorFields);
    }
  }, [t, trigger, errors]);

  return methods;
}
